<template>
    {{ test }}
</template>

<script>
export default {
    data() {
        return {
            test: 'test'
        }
    },

    mounted() {
        this.test = import.meta.env.VITE_FGPT_API_EVENTS_URL
    }
}
</script>
